module.exports = __webpack_public_path__ + "static/media/triangleArrow.06166e50.svg";